// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"92499bdf","238":"fb034b77","307":"09ad31db","453":"5eab263c","510":"aa162bbc","561":"189593f1","778":"7692d58b","833":"d6a02e82"}[chunkId] + ".chunk.js";
};